import { render, staticRenderFns } from "./SaleServiceOrderItem.vue?vue&type=template&id=18941bc6&scoped=true&"
import script from "./SaleServiceOrderItem.vue?vue&type=script&lang=js&"
export * from "./SaleServiceOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleServiceOrderItem.vue?vue&type=style&index=0&id=18941bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18941bc6",
  null
  
)

export default component.exports